// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"File_dropzone__YtfQP","fileWrapper":"File_fileWrapper__YHOVm","fileName":"File_fileName__uUkJc","deleteLink":"File_deleteLink__gNU2s","error":"File_error__4zFJ0"};